import Logger from 'observability/Logger';

const LOG = new Logger('EventOpsResources-eventOPSWidget');

const NAMESPACE = 'eventOPSWidget';

/**
 * Get a wrapper of the EventOPS widget JS library.
 *
 * @param {Window} _window
 * @return {Object} - event ops client
 */
export default (_window) => ({
    isLoaded: () => typeof _window !== 'undefined' && typeof _window[NAMESPACE] !== 'undefined',
    isReady: (...args) =>
        typeof _window !== 'undefined' &&
        typeof _window[NAMESPACE] !== 'undefined' &&
        _window[NAMESPACE].isReady(...args),
    init: (...args) => {
        LOG.info('EventOPS.init', ...args);
        return _window[NAMESPACE].init(...args);
    },
    updateInformation: (...args) => {
        LOG.info('EventOPS.updateInformation', ...args);
        return _window[NAMESPACE].updateInformation(...args);
    },
    create: (...args) => {
        LOG.info('EventOPS.create', ...args);
        return _window[NAMESPACE].create(...args);
    },
    destroy: (...args) => {
        LOG.info('EventOPS.destroy', ...args);
        return _window[NAMESPACE].destroy(...args);
    },
});
